import { IEntity, IEquatable } from '../types';
import { isEntity } from '../utils';

/**
 * Retrieves the ID of a category or an object that implements IEquatable.
 * @param value - The category or object to retrieve the ID from.
 * @returns The ID of the category or object as a string.
 */
export function asEntityId(value: undefined): undefined;
export function asEntityId(value: string): string;
export function asEntityId(value: number): number;
export function asEntityId(value: IEntity | IEquatable): string | number;
export function asEntityId(value: IEntity | IEquatable | undefined): string | number | undefined;
export function asEntityId(value: IEntity | string | number | undefined): string | number | undefined {
  return isEntity(value) ? value.id : value;
}
